import { JsonConverter, JsonCustomConvert } from 'json2typescript';

import { Nature } from '../../../../../core';

@JsonConverter
export class NatureAdapter implements JsonCustomConvert<Nature | undefined> {
    serialize(nature: Nature): any | undefined {
        return nature ? String(nature) : undefined;
    }

    deserialize(nature: any): Nature | undefined {
        switch (nature) {
            case 'Nature':
            case 'F':
                return Nature.NATURAL;
            case 'Legal':
            case 'J':
                return Nature.COMPANY;
            default:
                return undefined;
        }
    }
}
